import { useCallback, useContext } from "react";
import { ImageClusterPanel } from "@radarly/models/panel";
import { Action } from "../action";
import ChannelContext from "../context";

export function useOpenImageClusterPanel() {
  const { dispatch } = useContext(ChannelContext);
  return useCallback(
    (
      clusters: ImageClusterPanel["clusters"],
      key: ImageClusterPanel["key"],
      onClose?: () => void
    ) => {
      dispatch(
        Action.panelOpened({
          type: "image-cluster",
          clusters,
          key,
          onClose,
        })
      );
    },
    [dispatch]
  );
}
